module.exports = __webpack_public_path__ + "media/images/butler-county-9889ba8e44efeeca71e13f550da07473.png";